import React from 'react';
import {
	RoadmapChartItemContentLite,
	getPlaceholder,
} from '@atlassian/jira-software-roadmap-timeline-table-kit';
import { getColor } from '../../../common/utils/get-color';
import type { TimelineViewIssue } from '../../../types';

type ChartItemContentLiteProps = {
	issue: TimelineViewIssue;
	startDate: number | undefined;
	dueDate: number | undefined;
	level: number;
};

export const ChartItemContentLite = (props: ChartItemContentLiteProps) => {
	const { issue, startDate, dueDate, level } = props;
	const { status, startDate: actualStartDate, dueDate: actualDueDate } = issue;

	const color = getColor(status.categoryId);

	return (
		<RoadmapChartItemContentLite
			color={color}
			startDate={startDate}
			dueDate={dueDate}
			placeholder={getPlaceholder(!actualStartDate, !actualDueDate)}
			level={level}
		/>
	);
};
